export function mobileTimeWheelPad2(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

export function mobileTimeWheelFormat(hour: number, minute: number): string {
  return `${mobileTimeWheelPad2(hour)}:${mobileTimeWheelPad2(minute)}`;
}

export function mobileTimeWheelParse(value: string | null | undefined): {
  hour: number;
  minute: number;
} | null {
  if (value == null || value.trim() === "") {
    return null;
  }
  const match = /^(\d{1,2}):(\d{2})$/.exec(value.trim());
  if (!match) {
    return null;
  }
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (!Number.isInteger(hour) || !Number.isInteger(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) {
    return null;
  }
  return { hour, minute };
}

export function mobileTimeWheelMinuteValues(step: number): number[] {
  const normalizedStep = Math.max(1, Math.min(30, Math.floor(step)));
  const out: number[] = [];
  for (let minute = 0; minute < 60; minute += normalizedStep) {
    out.push(minute);
  }
  return out;
}

export function mobileTimeWheelSnapMinute(minute: number, step: number): number {
  const normalizedStep = Math.max(1, Math.min(30, Math.floor(step)));
  const clamped = Math.max(0, Math.min(59, minute));
  return Math.floor(clamped / normalizedStep) * normalizedStep;
}
